module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"positive":"Positive","negative":"Negative","undetermined":"Undetermined","not tested":"Untested","pending":"In Progress","yes":"Yes","no":"No"},"fr":{"positive":"Positif","negative":"Negatif","undetermined":"Indéterminée","not tested":"Non testé","pending":"En cours","yes":"Oui","no":"Non"}}')
  delete Component.options._Ctor
}
